import { render } from "./UserAgreement.vue?vue&type=template&id=bbdb3c0a&scoped=true"
const script = {}

import "./UserAgreement.vue?vue&type=style&index=0&id=bbdb3c0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbdb3c0a"]])

export default __exports__